import React, { useEffect } from 'react';
import './BarterKingDrawer.css'; // reuse same styles

export default function MerchantStarDrawer({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="bkdr-overlay" role="dialog" aria-modal="true" aria-label="About Merchant Star">
      <div className="bkdr-scrim" onClick={onClose} />
      <div className="bkdr-sheet" tabIndex={-1}>
        <div className="bkdr-handle" />
        <div className="bkdr-header">
          <div className="bkdr-emoji" aria-hidden>🛍️</div>
          <div className="bkdr-title">Merchant Star</div>
          <button className="bkdr-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="bkdr-content">
          <p className="bkdr-lead">
            Merchant Star highlights the top sellers on BarterFi in the current reward period.
          </p>

          <ul className="bkdr-list">
            <li><b>What counts?</b> Real completed sales in the marketplace.</li>
            <li><b>Who gets it?</b> The top merchants on the leaderboard.</li>
            <li><b>What helps?</b> More sales, more completed orders, and good store performance.</li>
            <li><b>How to climb?</b> Keep your store active and fulfill orders well.</li>
          </ul>

          <div className="bkdr-hint">
            Great service and steady sales help you rise faster.
          </div>
        </div>
      </div>
    </div>
  );
}
